import React from 'react';
import { useDropzone } from 'react-dropzone';
import { parse } from 'papaparse';
import Button from '../Button';

const CSVUpload = ({ onFetchData, buttonName }) => {
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    accept: '.csv',
    onDrop: (acceptedFiles) => {
      Array.from(acceptedFiles).forEach(async (file) => {
        const text: string = await file.text();
        const parseData = parse(text, { header: true });

        // Filter out empty rows before passing to onFetchData
        const filteredData = parseData.data.filter((row: any) => {
          return row.Number && row.Number.trim() !== '';
        })

        const cleanedFilteredData = filteredData.map((row: any) => {
          const cleanedRow: any = {};

          Object.keys(row).forEach((key: any) => {
            // Only keep keys that are not empty and have non-empty values.
            if (key && key.trim() !== '' && !key.startsWith('_')) {
              const value = row[key];
              // Only add if value exists (even if empty string - might be intentional).
              if (value !== undefined && value !== null) {
                cleanedRow[key] = value;
              }
            }
          })

          return cleanedRow;
        });

        onFetchData(cleanedFilteredData);
      });
    },
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <Button color="teal" label={buttonName} onClick={open} size="small" />
    </div>
  );
};

export default CSVUpload;
